<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.competencies') }}</h3>
                </div>
                <div class="col-6 text-right">
                    <base-button type="primary" size="sm" @click="ctrl.create()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-e-add"></i></span>
                        <span class="btn-inner--text">{{ $t('competencies.new') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('competencies.no-competency') }}</p>

        <div class="pt-2" v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column label="en">
                    <template v-slot="{row}">
                        <h4 class="mb-0" :class="{'disabled': !row.active}">
                            {{ row.name_en }}
                        </h4>
                        <badge rounded v-if="row.domain"
                            :type="row.domain.color"
                            :class="{'disabled': !row.active}"
                            class="mt-2"
                        >
                            {{ row.domain.name_en }}
                        </badge>
                    </template>
                </el-table-column>

                <el-table-column label="fr">
                    <template v-slot="{row}">
                        <h4 class="mb-0" :class="{'disabled': !row.active}">
                            {{ row.name_fr }}
                        </h4>
                        <badge rounded v-if="row.domain"
                            :type="row.domain.color"
                            :class="{'disabled': !row.active}"
                            class="mt-2"
                        >
                            {{ row.domain.name_fr }}
                        </badge>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.order')" width="70">
                    <template v-slot="{row}">
                        {{ row.position }}
                    </template>
                </el-table-column>

                <el-table-column width="80"
                    :label="$t('common.origin')"
                >
                    <template v-slot="{row}">
                        <badge type="warning" v-if="row.origin == 'local'">{{ row.origin }}</badge>
                        <badge type="secondary" v-else>{{ row.origin }}</badge>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="120" class-name="actions">
                    <template v-slot="{row}">
                        <div class="table-actions">

                            <a href="#" class="table-action text-danger" @click.prevent="ctrl.delete(row.id)">
                                <i class="tim-icons icon-simple-remove"></i>
                            </a>

                            <a href="#" class="table-action text-primary" @click.prevent="ctrl.update(row.id)">
                                <i class="tim-icons icon-pencil"></i>
                            </a>
                        </div>
                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <form-modal v-model="ctrl.modals.edit"
                :title="$t('common.competency')"
                :loading="ctrl.form.loading"
            >
                <competency-form v-model="ctrl.form.data"
                    :errors="ctrl.form.errors"
                    :modal="ctrl.modals.edit"
                    :domains="domainsSelect"
                >
                </competency-form>
            </form-modal>

            <confirm-modal v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('competencies.delete-confirm') }}</p>
            </confirm-modal>

        </portal>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import CompetencyForm from './CompetencyForm'
    import CompetencyMapping from './CompetencyMapping'

    export default {

        components: {
            CompetencyForm
        },

        props: {
            domains: {
                type: Array,
                required: true
            },
        },

        data() {
            let mapping = new CompetencyMapping()
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/socrates/api/front/competencies',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['position'],
                        relations: ['domain'],
                    },
                    errors: {
                        '423-delete': 'competencies.423-delete',
                    }
                }),
                search: '',
            }
        },

        computed: {

            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            },

            domainsSelect() {
                let select = {}
                this.domains.forEach(domain => {
                    if (domain.active) {
                        select[domain.id] = domain.name_en
                    }
                })
                return select
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({$or: [
                    {name_en: {$text: val}},
                    {name_fr: {$text: val}},
                ]})
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }

    .card >>> th.actions,
    .card >>> td.actions {
        padding-right: 1.5rem;
    }

    h4.disabled {
        color: #bbb !important;
    }
    .card >>> .badge.disabled {
        color: #bbb !important;
        background-color: #eee !important;
    }

    .card >>> .table-control form {
        width: 100%;
    }

</style>
